import React from 'react';
import { Alert, Typography } from 'antd';
import type { RouteViewModel } from '../../../types/routeViewModel';
import type { CorrectionContext } from '../hooks/useCorrectionContext';

const { Text } = Typography;

export const DOGRUZ_IN_DEVELOPMENT_LABEL = 'В разработке';

type WizardTriggerProps = {
  routeId: number;
  view: RouteViewModel;
  ctx: CorrectionContext;
  onSuccess: () => void;
  buttonLabel?: string;
  autoOpen?: boolean;
};

/**
 * Dogruz stays visible and cannot start an operation.
 * The unused props keep the call sites stable without mounting the wizard.
 */
export function CargoSegmentWizardTrigger(_props: WizardTriggerProps) {
  return (
    <Alert
      type="info"
      showIcon
      message={`Догруз — ${DOGRUZ_IN_DEVELOPMENT_LABEL}`}
      description="Операция догруза недоступна. Мастер не открывается и запросы к API догруза не отправляются."
    />
  );
}

type Props = {
  routeId: number;
  view: RouteViewModel;
  ctx: CorrectionContext;
  onSuccess: () => void;
};

export function CargoSegmentPanel(_props: Props) {
  return (
    <div className="mutation-workspace__section">
      <div className="mutation-workspace__section-title">Сегмент груза</div>
      <CargoSegmentWizardTrigger
        routeId={0}
        view={_props.view}
        ctx={_props.ctx}
        onSuccess={_props.onSuccess}
      />
      <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
        {DOGRUZ_IN_DEVELOPMENT_LABEL}
      </Text>
    </div>
  );
}
